import { render, staticRenderFns } from "./dropCarousCard.vue?vue&type=template&id=cf95e3ba&scoped=true"
import script from "./dropCarousCard.vue?vue&type=script&lang=js"
export * from "./dropCarousCard.vue?vue&type=script&lang=js"
import style0 from "./dropCarousCard.vue?vue&type=style&index=0&id=cf95e3ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf95e3ba",
  null
  
)

export default component.exports